<template>
  <div v-if="canRead">
    <backing-services></backing-services>
    <dead-letter-queues></dead-letter-queues>
    <div class="row">
      <div class="col-md-6">
        <recently-logged-in></recently-logged-in>
      </div>
      <div class="col-md-6">
        <recent-jobs-with-errors></recent-jobs-with-errors>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <jobs-with-blocked-invoices></jobs-with-blocked-invoices>
      </div>
    </div>
  </div>
</template>
<script>
  import BackingServices from 'src/components/Dashboard/Views/Dashboard/BackingServices'
  import DeadLetterQueues from 'src/components/Dashboard/Views/Dashboard/DeadLetterQueues'
  import RecentlyLoggedIn from 'src/components/Dashboard/Views/Dashboard/RecentlyLoggedIn'
  import RecentJobsWithErrors from 'src/components/Dashboard/Views/Dashboard/RecentJobsWithErrors'
  import JobsWithBlockedInvoices from 'src/components/Dashboard/Views/Dashboard/JobsWithBlockedInvoices'
  import Permissions from 'src/utilities/permissions'

  export default {
    components: {
      BackingServices,
      DeadLetterQueues,
      RecentlyLoggedIn,
      RecentJobsWithErrors,
      JobsWithBlockedInvoices
    },
    computed: {
      canRead() {
        return this.$can('read', Permissions.DASHBOARD)
      }
    },
    data () {
      return {}
    }
  }

</script>
<style scoped>

</style>
